import { Grid } from "@mui/material";
import { IconBoxMultiple9, IconCopy, IconTrash } from "@tabler/icons-react";
import MxIcons from "@rf-l1/MxIcons";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import { memo } from "react";
import { useBuildingDetail } from "../../context/BuildingDetailContext";
import MxMenu, { MxMenuItemProps } from "@rf-l1/MxMenu";
import { DuplicateCount } from "./building-table-units/building-units-form/BuildingUnitFormOptionsSection";
import { useBuildingsContext } from "@rf/property/module/components/property-form/septions/property-steps/buildings-step/context/Buildings-contexts/BuildingsContext";
import { useUnitsContext } from "@rf/property/module/components/property-form/septions/property-steps/buildings-step/context/UnitsContext";

const BuildingManagementControls = memo(() => {
  const { indexBuilding } = useBuildingDetail();
  const { addUnit } = useUnitsContext();
  const { deleteBuilding, duplicateBuilding } = useBuildingsContext();

  /**
   * Remove a catchment/building pair with validation
   */
  const removeItem = async () => {
    const buildingDeleted = await deleteBuilding(indexBuilding);
  };

  /**
   * Duplicate a catchment/building pair
   */
  const duplicateItem = async (count: number) => {
    const buildingDuplicated = await duplicateBuilding(indexBuilding, count);
  };

  const options: MxMenuItemProps<any>[] = [
    {
      label: "Duplicar edificio",
      icon: <IconBoxMultiple9 />,
      show: true,
      onClick: e => {
        duplicateItem(Number(e.context.detail.count || 1));
      },
      template: <DuplicateCount />
    }
  ];

  const handleDuplicateBuilding = () => {
    duplicateItem(1);
  };

  const handleAddUnit = () => {
    addUnit();
  };

  return (
    <Grid container spacing={1} alignItems="center" wrap="nowrap">
      <Grid item xs="auto">
        <MxIcons
          size={20}
          children={<IconCopy />}
          onClick={handleDuplicateBuilding}
        />
      </Grid>

      <Grid item xs="auto">
        <MxMenu items={options} width={250}>
          <MxIcons size={20} color="white" children={<IconBoxMultiple9 />} />
        </MxMenu>
      </Grid>

      <Grid item xs="auto">
        <MxIcons size={20} children={<IconTrash />} onClick={removeItem} />
      </Grid>

      <Grid
        item
        flex={1}
        display={{
          xs: "block",
          lg: "none",
          xl: "none"
        }}
      />

      <Grid item xs="auto">
        <MxButton2
          variant="contained"
          onClick={handleAddUnit}
          bgColor={"background.paper"}
          textColor="primary.main"
          testId="add-unit-button"
        >
          Agregar unidad
        </MxButton2>
      </Grid>
    </Grid>
  );
});

export default memo(BuildingManagementControls);
BuildingManagementControls.displayName = "BuildingManagementControls";
